import { render, staticRenderFns } from "./AnaliseSocioAmbiental.vue?vue&type=template&id=cfa93530&scoped=true&lang=pug"
import script from "./AnaliseSocioAmbiental.vue?vue&type=script&lang=js"
export * from "./AnaliseSocioAmbiental.vue?vue&type=script&lang=js"
import style0 from "./AnaliseSocioAmbiental.vue?vue&type=style&index=0&id=cfa93530&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa93530",
  null
  
)

export default component.exports